import {
  Modal,
  Button,
  Col,
  Card,
  Row,
  Form,
  Container,
} from "react-bootstrap";
import { metaServices } from "../../../APIServices/VoultManagement/metaServices";
import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import Pagination from "../../../Hooks/Pagination";
import noPreview from "../../../Img/noPreview.jpeg";

const UploadedImageModal = ({ Show, Hide, Title, onSelect }) => {
  const [imageLibraryList, setImageLibraryList] = useState([]);
  const [imageLibraryCount, setImageLibraryCount] = useState(0);
  const [searchData, setSearchData] = useState("");
  const [previewImage, setPreviewImage] = useState("");

  const handleSelect = (icon) => {
    onSelect?.(icon);
    Hide();
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(24);
  const totalPage = Math.ceil(imageLibraryCount / itemsPerPage);

  const getMetadataList = async () => {
    let data = await metaServices.getMetadataList(
      "active",
      "otherImageLibrary",
      searchData,
      pageNumber,
      itemsPerPage,
    );
    setImageLibraryList(data?.data || []);
    setImageLibraryCount(data?.count || 0);
  };

  const [loader, setLoader] = useState(false);

  const [name, setName] = useState("");
  const [key, setKey] = useState("");

  const [icon, setIcon] = useState("");
  const [iconValue, setIconValue] = useState("");
  const [iconPreview, setIconPreview] = useState("");

  const addNewMetadata = async () => {
    setLoader(true);
    const userData = {
      categoryId: "otherImageLibrary",
      name,
      key,
      icon,
    };
    const data = await metaServices.addNewMetadata(userData);
    if (data?.statusCode === 200) {
      setName("");
      setKey("");
      setIcon("");
      setIconValue("");
      setIconPreview("");
      setPreviewImage("")
      getMetadataList();
    }
    setLoader(false);
  };

  useEffect(() => {
    getMetadataList();
  }, [searchData, pageNumber, itemsPerPage]);

  return (
    <Modal show={Show} onHide={Hide} size="xl">
      <Modal.Header closeButton className="bg-light p-3 border-bottom">
        <Modal.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-0">
        <div className="hstack gap-2 py-2 px-2 bg-light">
          <Button
            size="sm"
            variant="outline-primary"
            className="hstack gap-2 text-nowrap rounded-1 border"
            style={{ fontSize: 13 }}
            onClick={() => setPreviewImage("addImage")}
          >
            <FaPlus /> {"Add New"}
          </Button>
          <div className="search-box position-relative w-100">
            <FiSearch />
            <Form.Control
              type="search"
              className="w-100 rounded-1"
              style={{ fontSize: 13 }}
              placeholder="Search..."
              value={searchData}
              onChange={(e) => setSearchData(e.target.value)}
            />
          </div>
        </div>
        <Container fluid>
          <Row>
            <Col
              md={previewImage ? 8 : 12}
              className={`${previewImage && "border-end"} p-0`}
            >
              <Container
                fluid
                className="overflow-auto border-bottom"
                style={{ height: "calc(100vh - 210px)" }}
              >
                <Row className="g-2 py-2">
                  {imageLibraryList?.map((item, index) => {
                    const isActive = previewImage?.name === item?.name;

                    return (
                      <Col
                        key={item?.name || index}
                        xxl={previewImage ? 3 : 2}
                        xl={previewImage ? 3 : 2}
                        lg={previewImage ? 4 : 3}
                        md={previewImage ? 6 : 4}
                        sm={previewImage ? 4 : 6}
                      >
                        <Card
                          className={`text-center p-3 CP ${
                            isActive ? "border-primary shadow-sm" : "border"
                          }`}
                          style={{ transition: "all 0.2s ease-in-out" }}
                          title={item?.name}
                          onClick={() => {setPreviewImage(item)}}
                        >
                          <Card.Body className="p-0">
                            <img
                              className="w-auto"
                              src={item?.icon}
                              alt={item?.name}
                              style={{ height: 40 }}
                            />

                            <Card.Title
                              className={`fw-bold mt-3 m-0 ${
                                isActive ? "text-primary" : ""
                              }`}
                              style={{ fontSize: 12 }}
                            >
                              {item?.name}
                            </Card.Title>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </Row>
              </Container>
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={imageLibraryCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </Col>
            {previewImage && previewImage !== "addImage" && (
              <Col md={4} className="p-0">
                <div className="p-2 border-bottom hstack justify-content-between">
                  <h6 className="m-0">{previewImage?.name}</h6>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => setPreviewImage("")}
                    className="hstack gap-2 text-nowrap rounded-1"
                    style={{ fontSize: 13 }}
                  >
                    {"Close"}
                  </Button>
                </div>
                <div
                  className="text-center overflow-auto p-3"
                  style={{ height: "calc(100vh - 257px)" }}
                >
                  <img
                    className="w-100"
                    src={previewImage?.icon}
                    alt={previewImage?.name}
                    style={{ height: "auto" }}
                  />
                </div>
                <div className="border-top p-2 hstack gap-2">
                  <Button
                    size="sm"
                    variant="outline-primary"
                    className="hstack gap-2 text-nowrap rounded-1"
                    style={{ fontSize: 13 }}
                  >
                    {"Copy Link"}
                  </Button>
                  <Button
                    size="sm"
                    variant="primary"
                    className="hstack gap-2 text-nowrap rounded-1"
                    style={{ fontSize: 13 }}
                    onClick={() => handleSelect(previewImage?.icon)}
                  >
                    {"Select Image"}
                  </Button>
                </div>
              </Col>
            )}
            {previewImage === "addImage" && (
              <Col md={4} className="p-0">
                <div className="p-2 border-bottom hstack justify-content-between">
                  <h6 className="m-0">Add New Image</h6>
                  <Button
                    size="sm"
                    variant="outline-danger"
                    onClick={() => setPreviewImage("")}
                    className="hstack gap-2 text-nowrap rounded-1"
                    style={{ fontSize: 13 }}
                  >
                    {"Close"}
                  </Button>
                </div>
                <div
                  className="p-3 overflow-auto"
                  style={{ height: "calc(100vh - 257px)" }}
                >
                  <Form.Group className="mb-2">
                    <Form.Label
                      className="fw-bold mb-1"
                      style={{ fontSize: 13 }}
                    >
                      Name
                    </Form.Label>
                    <Form.Control
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter Name"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label
                      className="fw-bold mb-1"
                      style={{ fontSize: 13 }}
                    >
                      Key
                    </Form.Label>
                    <Form.Control
                      value={key}
                      onChange={(e) =>
                        setKey(e.target.value.toLowerCase().replace(/\s+/g, ""))
                      }
                      placeholder="Enter Key"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label
                      className="fw-bold mb-1"
                      style={{ fontSize: 13 }}
                    >
                      Search Icon
                    </Form.Label>
                    <Form.Control
                      value={iconValue}
                      onChange={(e) => {
                        const val = e.target.value;
                        setIconValue(val);
                        if (!val) {
                          setIcon("");
                          setIconPreview("");
                        } else {
                          setIconPreview("");
                        }
                      }}
                      placeholder="visa, mastercard..."
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="text-center">
                    <Form.Label
                      className="fw-bold mb-0"
                      style={{ fontSize: 13 }}
                    >
                      OR
                    </Form.Label>
                  </Form.Group>
                  <Form.Group className="mb-2">
                    <Form.Label
                      className="fw-bold mb-1"
                      style={{ fontSize: 13 }}
                    >
                      Icon URL
                    </Form.Label>
                    <Form.Control
                      value={iconPreview}
                      onChange={(e) => {
                        setIconPreview(e.target.value);
                        setIconValue("");
                        setIcon("");
                      }}
                      placeholder="https://example.com/icon.png"
                      style={{ fontSize: 12 }}
                    />
                  </Form.Group>
                  <Form.Group className="mt-4 mb-2 text-center">
                    <img
                      width="100"
                      alt="preview"
                      src={
                        iconValue
                          ? `https://cdn.simpleicons.org/${iconValue}`
                          : iconPreview || noPreview
                      }
                      onLoad={(e) => {
                        if (e.target.src !== noPreview) {
                          setIcon(e.target.src);
                        }
                      }}
                      onError={(e) => {
                        e.target.src = noPreview;
                        setIcon("");
                      }}
                      style={{
                        border: "1px solid #ddd",
                        borderRadius: 6,
                        padding: 6,
                        background: "#fff",
                      }}
                    />
                  </Form.Group>
                </div>
                <div className="border-top p-2 hstack justify-content-end gap-2">
                  <Button
                    size="sm"
                    variant="primary"
                    disabled={!name || !key || !icon || loader}
                    onClick={addNewMetadata}
                    className="text-nowrap rounded-1"
                    style={{ fontSize: 13 }}
                  >
                    {"Add Image"}
                  </Button>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  );
};

export default UploadedImageModal;
